import { useMatter } from "../../contexts/MatterContext";
import { useSeenState } from "../../contexts/SeenStateContext";
import { Subheading } from "../../design/heading";
import { Table, TableBody, TableCell, TableRow } from "../../design/table";

interface SeenStateListProps {
  eventId?: string;
  fileId?: string;
  participantId?: string;
  documentId?: string;
}

const SeenStateList = ({
  eventId,
  fileId,
  participantId,
  documentId,
}: SeenStateListProps) => {
  const { currentMatter } = useMatter();
  // const { seenStates } = useSeenState();

  // const path = eventId
  //   ? `events:${eventId}`
  //   : fileId
  //     ? `files:${fileId}`
  //     : participantId
  //       ? `participants:${participantId}`
  //       : `documents:${documentId}`;
  // const seenState = seenStates.find((seenState) => seenState._id === path);

  return null;

  // return (
  //   <div className="my-4">
  //     <Table>
  //       <TableBody>
  //         {profiles.map((profile) => {
  //           const lastSeen = seenState?.seenStates[profile._id]
  //             ? new Date(seenState.seenStates[profile._id])
  //             : null;
  //           return (
  //             <TableRow key={profile._id}>
  //               <TableCell>
  //                 {profile.firstName} {profile.lastName}
  //               </TableCell>
  //               <TableCell>
  //                 {lastSeen ? lastSeen.toLocaleString() : "Not seen"}
  //               </TableCell>
  //             </TableRow>
  //           );
  //         })}
  //       </TableBody>
  //     </Table>
  //   </div>
  // );
};

export default SeenStateList;
